// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    signUp: `${ROOTS.AUTH}/sign-up`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    scenarios: `${ROOTS.DASHBOARD}/scenarios`,
    organizations: `${ROOTS.DASHBOARD}/organizations`,
    userResults: `${ROOTS.DASHBOARD}/user-results`,
    admins: `${ROOTS.DASHBOARD}/admins`,
    logs: `${ROOTS.DASHBOARD}/logs`,
  },
};
